import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  removeApprover,
  setAssigneeRole as setApproverRole,
  setAssigneeUser as setApproverUser,
} from './store/workflow/actions';

import startCase from 'lodash/startCase';

import ManagedInput from 'components/form/managed_input';
import Options from 'components/form/managed_input/options';
import RemoveControl from './remove_control';

const typeOptions = {
  role: 'Role',
  user: 'User',
};

export const Approver = ({
  approver,
  approverGroup,
  removeApprover,
  roles,
  setApproverRole,
  setApproverUser,
  step,
  users,
}) => {
  const [role, setRole] = useState(approver.role || roles[0]);
  const [type, setType] = useState(approver.role ? 'role' : 'user');
  const [user, setUser] = useState(approver.user || users[0]);

  useEffect(() => {
    if (type === 'role') {
      setApproverRole(step, approverGroup, approver, role || null);
    } else {
      setApproverUser(step, approverGroup, approver, user || null);
    }
  }, []);

  const handleTypeChange = (type) => {
    if (!type) {
      return;
    }

    setType(type);

    if (type === 'role') {
      setApproverRole(step, approverGroup, approver, role || null);
    } else {
      setApproverUser(step, approverGroup, approver, user || null);
    }
  };

  const handleRoleChange = (value) => {
    const role = roles.find(role => role.value === value);

    setRole(role);
    setApproverRole(step, approverGroup, approver, role);
  };

  const handleUserChange = (id) => {
    const user = users.find(user => user.id.toString() === id);
    setUser(user);
    setApproverUser(step, approverGroup, approver, user);
  };

  const handleRemoveApprover = () => {
    removeApprover(step, approverGroup, approver);
  };

  return (
    <div className="task-workflow-approver">
      <b className="mr-3">Approver {approver.index + 1}</b>
      <ManagedInput
        aria-label="approver-type-select"
        className="form-control"
        type="select"
        value={type}
        onValueChange={handleTypeChange}
      >
        <Options options={typeOptions} />
      </ManagedInput>

      {type === 'user' && (
        <ManagedInput
          className="form-control"
          type="select"
          value={approver.user?.id}
          onValueChange={handleUserChange}
        >
          {users.map(user => (
            <option key={user.id} value={user.id}>
              {user.name}
            </option>
          ))}
        </ManagedInput>
      )}
      {type === 'role' && (
        <ManagedInput
          className="form-control"
          type="select"
          value={approver.role?.value}
          onValueChange={handleRoleChange}
        >
          {roles.map(role => (
            <option key={role.value} value={role.value}>
              {startCase(role.label)}
            </option>
          ))}
        </ManagedInput>
      )}
      <RemoveControl ariaLabel="remove-approver" onClick={handleRemoveApprover} />
    </div>
  );
};

Approver.propTypes = {
  approver: PropTypes.shape({
    role: PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    }),
    user: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })
  }).isRequired,
  approverGroup: PropTypes.object.isRequired,
  removeApprover: PropTypes.func.isRequired,
  roles: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  setApproverRole: PropTypes.func.isRequired,
  setApproverUser: PropTypes.func.isRequired,
  step: PropTypes.object.isRequired,
  users: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired
};

const mapStateToProps = state => ({
  roles: state.static.roles,
  users: state.static.users
});

const mapDispatchToProps = {
  removeApprover,
  setApproverRole,
  setApproverUser
};

export default connect(mapStateToProps, mapDispatchToProps)(Approver);
